module.exports = __webpack_public_path__ + "static/media/head_pic.5a7b3cb9.svg";